"use client";

import { Instagram } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Separator } from "@/components/ui/separator";
function FooterNavConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        <div className="h-4 w-24 bg-muted/40 animate-pulse rounded-md" />
        <div className="h-4 w-24 bg-muted/40 animate-pulse rounded-md" />
        <div className="h-4 w-24 bg-muted/40 animate-pulse rounded-md" />
        <div className="h-4 w-24 bg-muted/40 animate-pulse rounded-md" />
      </div>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li data-index={i} key={item.id}>
          <Link to={item.href || "#"} className="text-[13px] font-default tracking-wide text-foreground/80 hover:text-primary transition-colors duration-300">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
const atelierPhotos = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700070/img/electric_panel_install.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700070/img/electric_panel_install.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700070/img/electric_panel_install.png-wvc-sizes",
  alt: "Professional electrical panel installation"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700070/img/electric_wiring_safety.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700070/img/electric_wiring_safety.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700070/img/electric_wiring_safety.png-wvc-sizes",
  alt: "Safety-focused residential wiring"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700070/img/electric_commercial_lighting.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700070/img/electric_commercial_lighting.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700070/img/electric_commercial_lighting.png-wvc-sizes",
  alt: "Commercial lighting solutions"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700070/img/electric_emergency_repair.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700070/img/electric_emergency_repair.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700070/img/electric_emergency_repair.png-wvc-sizes",
  alt: "Emergency electrical repair service"
}];
export default function FooterInformation() {
  return <section data-section-id="3191" id="footer-information" className="bg-background text-foreground pt-[120px] pb-10 px-6 md:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto">
        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 lg:gap-10">
          {}
          <div className="lg:col-span-5">
            <h2 className="font-default text-[48px] leading-none text-foreground tracking-[0.08em]">
              CURRENT PULSE
            </h2>
            <p className="mt-5 font-default italic text-[14px] text-primary tracking-wide">
              Licensed Electrical Contractors · Since 2010
            </p>
            <p className="mt-6 font-default text-[15px] leading-relaxed text-foreground/70 max-w-[220px]">
              Powering homes and businesses with precision, safety, and reliability.
            </p>
          </div>

          {}
          <div className="lg:col-span-2">
            <h3 className="font-default text-[11px] tracking-[0.25em] text-primary mb-6 uppercase">
              Navigation
            </h3>
            <MenuProvider menu_id="3">
              <FooterNavConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="lg:col-span-3">
            <h3 className="font-default text-[11px] tracking-[0.25em] text-primary mb-6 uppercase">
              Contact
            </h3>
            <div className="flex flex-col">
              <p className="font-default italic text-[14px] text-foreground/80 leading-relaxed pb-3">
                452 Voltage Way
                <br />
                Electric City, EC 90210
              </p>
              <Separator className="bg-border/30" />
              <Link to="tel:+15559876543" className="font-default italic text-[14px] text-foreground/80 hover:text-primary transition-colors duration-300 py-3">
                (555) 987-6543
              </Link>
              <Separator className="bg-border/30" />
              <Link to="mailto:support@currentpulse.com" className="font-default italic text-[14px] text-foreground/80 hover:text-primary transition-colors duration-300 pt-3">
                support@currentpulse.com
              </Link>
            </div>
          </div>

          {}
          <div className="lg:col-span-2">
            <h3 className="font-default text-[11px] tracking-[0.25em] text-primary mb-6 uppercase">
              Social
            </h3>
            <Link to="https://instagram.com/currentpulse" newTab className="inline-flex items-center gap-2 mb-5 group">
              <Instagram className="w-3.5 h-3.5 text-primary" />
              <span className="font-default italic text-[14px] text-foreground/80 group-hover:text-primary transition-colors duration-300">
                @currentpulse
              </span>
            </Link>
            <div className="grid grid-cols-2 gap-2 w-fit">
              {atelierPhotos.map((photo, i) => <Link to="https://instagram.com/currentpulse" newTab data-index={i} key={i} className="block border border-primary/40 hover:border-primary transition-colors duration-300">
                  <img src={photo.src} data-wvc-srcset={photo.srcset} data-wvc-sizes={photo.sizes} alt={photo.alt} loading="lazy" decoding="async" className="w-[60px] h-[60px] object-cover" />
                </Link>)}
            </div>
          </div>
        </div>

        {}
        <div className="mt-20 h-px w-full bg-primary/60" />

        {}
        <div className="mt-6 flex flex-col md:flex-row items-center justify-between gap-4 md:gap-0">
          <p className="font-default text-[11px] tracking-[0.15em] text-foreground/50 order-2 md:order-1">
            © Current Pulse Electric · All Rights Reserved
          </p>
          <div className="order-1 md:order-2 hidden md:block text-primary text-sm">
            ◆
          </div>
          <p className="font-default italic text-[12px] text-foreground/60 order-3">
            Engineered for safety and performance
          </p>
        </div>
      </div>
    </section>;
}